import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import axiosInstance from "../../../../hooks/axiosInstance";
import { Spinner } from "react-bootstrap";
import { COUNTRY_CODES } from "../../../../constants/countryCodes";

export default function CreateAccount({ show, closeModal, refreshPage }) {
    const [validationError, setValidationError] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [baseUser, setBaseUser] = useState([]);
    const countryCodes = COUNTRY_CODES;

    const [formData, setFormData] = useState({
        base_user_id: "",
        company_name: "",
        domain_name: "",
        email: "",
        phone: "",
        country_code: "+234",
    });

    // Fetch base users
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosInstance.get(
                    `/user/base_user/fetch_base_user_no_paginate`
                );
                setBaseUser(response.data.data.base_user);
            } catch (error) {
                console.error("Error fetching data", error);
            }
        };
        fetchData();
    }, []);

    const resetForm = () => {
        setFormData({
            base_user_id: "",
            company_name: "",
            domain_name: "",
            email: "",
            phone: "",
            country_code: "+234", // Reset to USA
        });
        setValidationError({});
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            // Allow only numbers for phone
            const numericValue = value.replace(/[^0-9]/g, "");
            setFormData((prev) => ({ ...prev, phone: numericValue }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleClose = () => {
        resetForm();
        closeModal();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            // Combine country code and phone number for submission
            const payload = {
                ...formData,
                phone: `${formData.country_code}${formData.phone}`,
            };

            const response = await axiosInstance.post("/user/account/add_account", payload);
            console.log("Account created:", response.data);
            toast.success("Account requested successfully");

            handleClose();
            refreshPage();
        } catch (error) {
            console.error("Error creating account:", error);
            if (error.response && error.response.data && error.response.data.errors) {
                setValidationError(error.response.data.errors);
            } else {
                toast.error("Error requesting account. Please try again.");
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="CreateUser">
            <Modal show={show} onHide={handleClose}>
                <Form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add User Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group controlId="accountInput">
                            <div className="input-group mb-2">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        Base User Name
                                    </span>
                                </div>
                                <select
                                    className="form-control custom-select"
                                    name="base_user_id"
                                    value={formData.base_user_id}
                                    onChange={(e) =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            base_user_id: e.target.value,
                                        }))
                                    }
                                >
                                    <option value="">-- Select Base user --</option>
                                    {baseUser.map((user) => (
                                        <option
                                            key={user.base_user_id}
                                            value={user.base_user_id}
                                        >
                                            {user.first_name} {user.last_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {validationError.base_user_id && (
                                <small className="text-danger my-1">
                                    {validationError.base_user_id[0]}
                                    -                                    </small>
                            )}
                        </Form.Group>
                        <br />
                        <Form.Group className="mb-3" controlId="formBasicname">
                            <div>
                                <h6>Company Name</h6>
                            </div>
                            <Form.Control
                                type="text"
                                placeholder="Enter..."
                                name="company_name"
                                value={formData.company_name}
                                onChange={handleChange}
                                required
                            />
                            {validationError.company_name && (
                                <small className="text-danger my-1">
                                    {validationError.company_name[0]}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicname">
                            <div>
                                <h6>Domain Name</h6>
                            </div>
                            <Form.Control
                                type="text"
                                placeholder="Enter..."
                                name="domain_name"
                                value={formData.domain_name}
                                onChange={handleChange}
                                required
                            />
                            {validationError.domain_name && (
                                <small className="text-danger my-1">
                                    {validationError.domain_name[0]}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicname">
                            <div>
                                <h6>Email</h6>
                            </div>
                            <Form.Control
                                type="email"
                                placeholder="Enter..."
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                            {validationError.email && (
                                <small className="text-danger my-1">
                                    {validationError.email[0]}
                                </small>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicPhone">
                            <div>
                                <h6>Phone</h6>
                            </div>
                            <div className="input-group">
                                <select
                                    name="country_code"
                                    value={formData.country_code}
                                    onChange={handleChange}
                                    className="form-control"
                                    style={{ width: "40%" }}
                                >
                                    {countryCodes.length === 0 ? (
                                        <option>Loading...</option>
                                    ) : (
                                        countryCodes.map((country) => (
                                            <option key={country.code} value={country.code}>
                                                {country.label}
                                            </option>
                                        ))
                                    )}
                                </select>
                                <Form.Control
                                    type="tel"
                                    placeholder="Enter phone number..."
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                    className="form-control"
                                    style={{ width: "60%" }}
                                />
                            </div>
                            {validationError.phone && (
                                <small className="text-danger my-1">
                                    {validationError.phone[0]}
                                </small>
                            )}
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            style={{ backgroundColor: "#c4281b", color: "#fff" }}
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />{" "}
                                    Saving...
                                </>
                            ) : (
                                "Save"
                            )}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
}